<script setup lang="ts">
  import type { CheckboxRootEmits, CheckboxRootProps } from 'reka-ui'
  import type { HTMLAttributes } from 'vue'
  import { reactiveOmit } from '@vueuse/core'
  import { Check } from 'lucide-vue-next'
  import { CheckboxIndicator, CheckboxRoot, useForwardPropsEmits } from 'reka-ui'
  import { cn } from '@rapoo/element/lib/utils'

  const props = defineProps<CheckboxRootProps & { class?: HTMLAttributes['class'] }>()
  const emits = defineEmits<CheckboxRootEmits>()

  const delegatedProps = reactiveOmit(props, 'class')

  const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <CheckboxRoot
    v-bind="forwarded"
    :class="
      cn(
        'grid place-content-center peer size-4 shrink-0 rounded-full cursor-pointer border border-neutral-dark-default bg-neutral-light-default focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-brand-blue1 data-[state=checked]:border-brand-blue1 data-[state=checked]:text-white',
        props.class,
      )
    "
  >
    <CheckboxIndicator class="grid place-content-center text-current">
      <slot>
        <Check class="size-3" />
      </slot>
    </CheckboxIndicator>
  </CheckboxRoot>
</template>
